import { VerificationCheckData } from './types'

export const DESIGN_MATCHES_V2_LOAD = 'DESIGN_MATCHES_V2_LOAD'
export const designMatchesV2Load = (
  accountId: string,
  projectId: string,
  recordId: string
): DesignMatchesV2LoadAction => ({
  type: DESIGN_MATCHES_V2_LOAD,
  accountId,
  projectId,
  recordId
})

export const DESIGN_MATCHES_V2_LOAD_SUCCESS = 'DESIGN_MATCHES_V2_LOAD_SUCCESS'
export const designMatchesV2LoadSuccess = (
  data: VerificationCheckData
): DesignMatchesV2LoadSuccessAction => ({
  type: DESIGN_MATCHES_V2_LOAD_SUCCESS,
  data
})

export const DESIGN_MATCHES_V2_LOAD_FAILURE = 'DESIGN_MATCHES_V2_LOAD_FAILURE'
export const designMatchesV2LoadFailure = (
  error: Error
): DesignMatchesV2LoadFailureAction => ({
  type: DESIGN_MATCHES_V2_LOAD_FAILURE,
  error
})

export interface DesignMatchesV2LoadAction {
  type: typeof DESIGN_MATCHES_V2_LOAD
  accountId: string
  projectId: string
  recordId: string
}

interface DesignMatchesV2LoadSuccessAction {
  type: typeof DESIGN_MATCHES_V2_LOAD_SUCCESS
  data: VerificationCheckData
}

interface DesignMatchesV2LoadFailureAction {
  type: typeof DESIGN_MATCHES_V2_LOAD_FAILURE
  error: Error
}
